import { Box, Button, Group, Text, TextInput } from '@mantine/core';

import { useBotAllowedUserForm } from '../../hooks/useBotAllowedUserForm';
import { botTypes } from '../../types';

type AllowedUserFormProps = {
  onSubmit: (data: Parameters<botTypes.AddAllowedUser>[0]) => void;
  isLoading: boolean;
  initialValues?: Omit<botTypes.AllowedUser, '_id'>;
};

export const AllowedUserForm = ({ onSubmit, isLoading, initialValues }: AllowedUserFormProps) => {
  const form = useBotAllowedUserForm({ initialValues });

  const isFormError = Object.keys(form.errors).length > 0;

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <TextInput
        label="Имя"
        placeholder="Имя"
        value={form.values.name}
        onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
        my="sm"
        error={form.errors.name}
      />
      <Box h={25}>
        {isFormError && (
          <Text c="red" size="sm" ta="end">
            {Object.values(form.errors)[0] || 'Ошибка'}
          </Text>
        )}
      </Box>
      <Group justify="flex-end">
        <Button loading={isLoading} type="submit">
          {initialValues ? 'Сохранить' : 'Создать'}
        </Button>
      </Group>
    </form>
  );
};
